export const unixToDate = (unix: number): string => {
    if (unix.toString().length === 10) {
        const date = new Date(unix * 1000);
        return date.toLocaleDateString('en-US');
    }
    const date = new Date(unix);
    return date.toLocaleDateString('en-US');
};

export const dateToUnix = (date: any): number => {
    if (date instanceof Date) {
        return Math.floor(date.getTime() / 1000);
    }
    const toDateType = new Date(date);

    // round it to nearest minute
    return Math.floor(toDateType.getTime() / 1000000) * 1000;
};

export const getFirstDayOfYearUnix = (): number => {
    const currentYear = new Date().getFullYear();
    const firstDayOfYear = new Date(currentYear, 0, 1);
    return dateToUnix(firstDayOfYear);
};

export const getOneYearAgoUnix = (): number => {
    const currentDate = new Date();
    const oneYearAgo = currentDate.setFullYear(currentDate.getFullYear() - 1);
    return dateToUnix(oneYearAgo);
};

export const getSixMonthsAgoUnix = (): number => {
    const currentDate = new Date();
    const threeMonthsAgo = currentDate.setMonth(currentDate.getMonth() - 6);
    return dateToUnix(threeMonthsAgo);
};

export const getThreeMonthsAgoUnix = (): number => {
    const currentDate = new Date();
    const threeMonthsAgo = currentDate.setMonth(currentDate.getMonth() - 3);
    return dateToUnix(threeMonthsAgo);
};

export const getOneMonthAgoUnix = (): number => {
    const currentDate = new Date();
    const oneMonthAgo = currentDate.setMonth(currentDate.getMonth() - 1);
    return dateToUnix(oneMonthAgo);
};

export const getOneWeekAgoUnix = (): number => {
    const currentDate = new Date();
    const oneWeekAgo = currentDate.setDate(currentDate.getDate() - 7);
    return dateToUnix(oneWeekAgo);
};

export const getOneDayAgoUnix = (): number => {
    const currentDate = new Date();
    const oneDayAgo = currentDate.setDate(currentDate.getDate() - 1);
    return dateToUnix(oneDayAgo);
};

export const getStartingTimestampUnix = (timeframe: string): number => {
    if (timeframe === 'YTD') {
        return getFirstDayOfYearUnix();
    }
    if (timeframe === '1Y') {
        return getOneYearAgoUnix();
    }
    if (timeframe === '3M') {
        return getThreeMonthsAgoUnix();
    }
    if (timeframe === '1M') {
        return getOneMonthAgoUnix();
    }
    if (timeframe === '7D') {
        return getOneWeekAgoUnix();
    }
    if (timeframe === '1D') {
        return getOneDayAgoUnix();
    }
    return 1230958800;
};

export const removeNullAndUndefined = (obj: Record<string, any>): Record<string, any> =>
    Object.entries(obj).reduce((acc: Record<string, any>, [key, value]) => {
        if (value !== null && value !== undefined) {
            acc[key] = typeof value === 'object' ? removeNullAndUndefined(value) : value;
        }
        return acc;
    }, {});
